import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "antd";
import { AiFillSetting } from "react-icons/ai";
import styled from "styled-components";

import CompareGraphService from "../../service/compare-graph";
import ReduxActions from "../../redux/actions";
import TableControl from "../../component/table/TableControl";

const TableExtend = styled(TableControl)`
  margin-top: 0px;
  width: 100%;
`

export default function TableListParams(props) {
  const dispatch = useDispatch();
  const listParams = useSelector(state => state.compareGraph.listParams)
  const selectedParams = useSelector(state => state.compareGraph.selectedParams)
  
  
  useEffect(() => {
    const init = async() =>{
      let data = await CompareGraphService.searchParams()
      let procData = data.filter(d => !selectedParams.find(sp => sp.id == d.id))
      if(data) dispatch(ReduxActions.compareGraph.setListParams(procData))
    }

    init()
  }, [dispatch]);

  const column = [
    { title: "สถานี", dataIndex: "stations_name", align: "left", className: "cn allow-search", sorter: (a, b) => a.stations_name.localeCompare(b.stations_name), },
    { title: "เซนเซอร์", dataIndex: "sensor_name", align: "left", className: "cn allow-search", sorter: (a, b) => a.sensor_name.localeCompare(b.sensor_name), },
    { title: "พารามิเตอร์", dataIndex: "parameter_name", align: "left", className: "cn allow-search", sorter: (a, b) => a.parameter_name.localeCompare(b.parameter_name), },
    { title: <AiFillSetting/>, dataIndex: "select", align: "center", width: 40, className:"cell-select", 
    render: (_, record) => (
      <>
        <Button
        style={{backgroundColor: "#05BC9B", color: "#FFF"}}
          onClick={()=>{
              dispatch(ReduxActions.compareGraph.addSelectedParams(record))
              dispatch(ReduxActions.popup.toggleVisible(false))
          }}>
            เลือก
        </Button>
      </>
    ),
    },]


  return (
    <TableExtend
      className={
        "table-list-params" +
        (props.className ? props.className : "")
      }
      columns={column}
      data={listParams}
    />
  );
}
